import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import type { Control } from 'react-hook-form';
import type { DropDownResult } from '@myosh/odin-components';
import { useLazyGetUserByIdQuery } from '../../../redux/services/user';
import { UserFields } from '../../../utils/user-config';
import type { HierarchyDropdownValue } from '../../../@types/hierarchy-fields';

interface HierarchyFromPersonProps {
  control?: Control;
  parentFieldId?: number;
}

const useGetPersonHierarchies = ({ control, parentFieldId }: HierarchyFromPersonProps) => {
  const [hierarchies, setHierarchies] = useState<Record<string, HierarchyDropdownValue>>();
  const [selectedPersonId, setSelectedPersonId] = useState<number | undefined>(undefined);
  const [getUserById] = useLazyGetUserByIdQuery();

  const targetFieldValue: DropDownResult = useWatch({
    control,
    name: String(parentFieldId),
    disabled: !parentFieldId,
    exact: true,
  });

  useEffect(() => {
    if (targetFieldValue && Number(targetFieldValue.value)) {
      getUserById(
        {
          id: Number(targetFieldValue.value),
          fields: `${UserFields.occupation},${UserFields.userHierarchy}`,
        },
        true
      )
        .unwrap()
        .then((user) => {
          if (user.hierarchies) {
            setHierarchies(user.hierarchies as Record<string, HierarchyDropdownValue>);
          } else {
            setHierarchies(undefined);
          }
        })
        .catch(() => setHierarchies(undefined))
        .finally(() => {
          setSelectedPersonId(targetFieldValue.value as number);
        });
    } else {
      setHierarchies(undefined);
      setSelectedPersonId(undefined);
    }
  }, [targetFieldValue]);

  return { hierarchies, selectedPersonId };
};

export default useGetPersonHierarchies;
